import {
  LinkIcon,
  MailIcon,
  NoteIcon,
  PersonIcon,
  SyncIcon,
  UploadIcon
} from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Label } from "@primer/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Button } from '../../../components/buttons';
import { hocSinhFaceIdApi } from "../../../api/hocSinhFaceIdApi";
import Button from "../../../components/ui/button";
import DataTable from "../../../components/ui/data-table";
import Text from "../../../components/ui/text";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import UserAvatar from "../../../components/user-avatar";
import { useCommonContext } from "../../../contexts/common";
import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ILopSelectHocSinhRequest } from "../../../models/request/dm-lop/ILopSelectHocSinhRequest";
import { IHocSinhSelectResponeItem } from "../../../models/response/hoc-sinh/IHocSinhSelectRespone";
import { actions } from "../../../state/actions/actionsWrapper";
import { RootState } from "../../../state/reducers";
import HocSinhProfile from "../../hoc-sinh-profile";
import { ILopSelected } from "../../lop-hanh-chinh/LopHanhChinhPage";
interface IHocSinhListContainerProps {
  lopSelected: ILopSelected;
  onViewChanged: (tab: "hoc_sinh" | "phu_huynh") => void;
}

const HocSinhListContainer = (props: IHocSinhListContainerProps) => {
  const { checkAccesiableTo, translate } = useCommonContext();
  const dispatch = useDispatch();
  const { language } = useSelector((x: RootState) => x.common);
  const { lopSelected } = props;
  const { hocsinh_status, ds_hocsinh_theo_lops } = useSelector(
    (state: RootState) => state.danhMucWrapper.lop
  );
  const [isUploading, setIsUploading] = useState(false);
  const { nam_hoc } = useSelector((x: RootState) => x.common);
  const [filter, setFilter] = useState<ILopSelectHocSinhRequest>({
    dm_lop_ids: [],
  });
  const [isShowImageModal, setIsShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [danhSachHocSinhSlectedId, setDanhSachHocSinhSlectedId] = useState<
    number[]
  >([]);
  const [isShowLockConfirm, setIsShowLockConfirm] = useState<boolean>(false);
  const [isShowUnLockConfirm, setIsShowUnLockConfirm] =
    useState<boolean>(false);
  const [hocSinhEditing, setHocSinhEditing] = useState({ id: 0 });
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState<number | null>(
    null
  );

  const dataSource = useMemo(() => {
    return (ds_hocsinh_theo_lops ?? []).filter(
      (hs) => hs.trang_thai !== "Ẩn" && hs.dm_trangthaihocsinh_id !== 31
    );
  }, [ds_hocsinh_theo_lops]);

  const onSelectionChanged = (selectedRowKeys: number[]) => {
    setDanhSachHocSinhSlectedId(selectedRowKeys);
  };

  const handleRefresh = useCallback(() => {
    onSelectionChanged([]);
    dispatch(actions.danhMucWrapper.lop.selectHocSinhStart(lopSelected.dm_lop));
  }, [filter]);

  useEffect(() => {
    setFilter({ dm_lop_ids: [] });
  }, [nam_hoc]);

  useEffect(() => {
    if (lopSelected) {
      setFilter({ dm_lop_ids: [lopSelected.dm_lop.dm_lop_id] });
    }
  }, [lopSelected]);

  useEffect(() => {
    handleRefresh();
  }, [filter]);

  useEffect(() => {
    if (hocsinh_status === ePageBaseStatus.is_need_reload) {
      handleRefresh();
    }
  }, [hocsinh_status]);

  const handleEditClick = (data: any) => {
    setHocSinhEditing(data); // Cập nhật hocSinhEditing với dữ liệu hiện tại
    setIsShowModal(true); // Mở modal
  };

  const handleUploadFaceId = async (e: React.MouseEvent, studentId: number) => {
    e.preventDefault();
    try {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";

      input.onchange = async (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (!file) return;

        // Validate file
        if (file.size > 5 * 1024 * 1024) {
          NotifyHelper.Error("File quá lớn. Vui lòng chọn file nhỏ hơn 5MB");
          return;
        }

        if (!file.type.startsWith("image/")) {
          NotifyHelper.Error("Vui lòng chọn file ảnh");
          return;
        }

        try {
          setIsUploading(true);

          await hocSinhFaceIdApi.uploadFaceId(file, nam_hoc, studentId);

          NotifyHelper.Success("Upload Face ID thành công");
          setIsShowImageModal(false);
          handleRefresh();
        } catch (error: any) {
          console.error("Upload failed:", error);
          NotifyHelper.Error(error?.message || "Upload Face ID thất bại");
        } finally {
          setIsUploading(false);
        }
      };

      input.click();
    } catch (error) {
      console.error("Upload face ID failed:", error);
      NotifyHelper.Error("Upload Face ID thất bại");
    }
  };
  const handleCloseModal = () => {
    setIsShowImageModal(false);
    setSelectedImage(null);
    setSelectedStudentId(null);
    setIsUploading(false);
  };

  // Phân quyền các chức năng FaceID
  // const canView = checkAccesiableTo("hoc-sinh-faceid", "GET");
  // const canEdit = checkAccesiableTo("hoc-sinh-faceid", "PUT");
  // const canAdd = checkAccesiableTo("hoc-sinh-faceid", "POST");
  // const canDelete = checkAccesiableTo("hoc-sinh-faceid/{id}", "DELETE");
  // const canUpload = checkAccesiableTo("upload/faceid/{nam_hoc}/{ts_hocsinh_id}", "POST");

    const canView = true;
  const canEdit =  true;
  const canAdd =  true;
  const canDelete =  true;
  const canUpload =  true;

  // Kiểm tra quyền truy cập
  if (!canView) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 4 }}>
        <Text text="Bạn không có quyền xem FaceID" />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ p: 3 }}>
        <DataTable
          titleComponent={
            <Text
              text={`${translate("HocSinhListContainer.Title")} - ${lopSelected.ten_lop
                }`}
              sx={{
                fontSize: "24px",
              }}
            />
          }
          subTitle={`${translate("Base.Label.TotalCount")}: ${(
            dataSource?.length ?? 0
          ).toLocaleString()}`}
          searchEnable
          paging={{
            enable: true,
            pageSizeItems: [20, 50, 200, 500, 1000],
          }}
          height={`${window.innerHeight - 240}px`}
          actionComponent={
            <>
              <Button
                onClick={handleRefresh}
                isLoading={hocsinh_status === ePageBaseStatus.is_loading}
                disabled={danhSachHocSinhSlectedId.length > 0}
                leadingVisual={SyncIcon}
                size="medium"
                sx={{ mr: 1 }}
                text="Refresh"
              />
              <ActionMenu>
                <ActionMenu.Button variant="primary">
                  <Text text="Base.Label.Command" />
                </ActionMenu.Button>
                <ActionMenu.Overlay width="auto">
                  <ActionList showDividers>
                    {/* <ActionList.Item
											onSelect={() => setIsShowModalSetClass(true)}
											disabled={!isAccessibleInsert}
										>
											<ActionList.LeadingVisual >
												<MultiSelectIcon />
											</ActionList.LeadingVisual>
											<Text text="HocSinhListContainer.Label.SubClass" />
										</ActionList.Item> */}
                  </ActionList>
                </ActionMenu.Overlay>
              </ActionMenu>
            </>
          }
          selection={{
            mode: "multiple",
            keyExpr: "id",
            selectedRowKeys: danhSachHocSinhSlectedId,
            onSelectionChanged(keys) {
              onSelectionChanged(keys);
            },
          }}
          columns={[
            {
              dataField: "trang_thai",
              width: "150px",
              caption: translate("Trạng thái"),
              fixed: true,
              isMainColumn: true,
              cellRender: (data: IHocSinhSelectResponeItem) => {
                let color: any = "fg.default";
                switch (data.trang_thai) {
                  case "New Enrollment":
                    color = "accent.emphasis";
                    break;
                  case "Thôi học":
                    color = "danger.emphasis";
                    break;
                  case "Học sinh lên lớp chưa đóng phí":
                    color = "attention.emphasis";
                    break;

                  default:
                    break;
                }
                return (

                  <Box
                    sx={{
                      color: color
                      // color: "attention.emphasis"
                    }}
                  // variant={
                  //   data.trang_thai === "New Enrollment"
                  //     ? "accent"
                  //     : data.trang_thai === "Re-Enrollment"
                  //       ? "success"
                  //       : data.trang_thai === "Tiềm năng"
                  //         ? "sponsors"
                  //         : data.trang_thai === "Thôi học"
                  //           ? "danger"
                  //           : "default"
                  // }
                  >
                    <TextWithEllipse text={data.trang_thai} lineNumber={1} />
                  </Box>

                );
              },
            },


            {
              dataField: "faceid_image",
              width: "100px",
              caption: translate("FaceID"),
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#10375C" }}>
                        {data.faceid_image ? (
                          <div
                            onClick={() => {
                              setSelectedImage(data.faceid_image);
                              setSelectedStudentId(data.id);
                              setIsShowImageModal(true);
                            }}
                            style={{
                              cursor: "pointer",
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={data.faceid_image}
                              alt="Face ID"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                transition: "transform 0.2s ease",
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.transform = "scale(1.1)";
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            />
                          </div>
                        ) : (
                          canUpload && (
                            <Button
                              variant="primary"
                              size="small"
                              leadingVisual={UploadIcon}
                              onClick={(e) => handleUploadFaceId(e, data.id)}
                              sx={{
                                minWidth: "auto",
                                padding: "4px 8px",
                              }}
                            >
                              Upload
                            </Button>
                          )
                        )}
                      </div>
                    </div>
                  </Box>
                );
              },
            },
            {
              dataField: "avatar",
              width: "100px",
              caption: translate("Avatar"),
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#10375C" }}>
                        <UserAvatar fullName={data.ho_ten} size="xlarge" />
                      </div>
                    </div>
                  </Box>
                );
              },
            },
            {
              caption: translate("Base.Label.StudentCode"),
              dataField: "ma_hs",
              width: "100px",
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <NoteIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.ma_hs || "..."}
                    </span>
                  </div>
                );
              },
            },
            {
              caption: translate("Base.Label.StudentName"),
              width: "200px",
              dataField: "ho_ten",
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <PersonIcon size={14} />
                    </div>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEditClick(data);
                      }}
                      style={{
                        marginLeft: "5px",
                        fontWeight: 600,
                        color: "#133E87",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.textDecoration = "underline")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.textDecoration = "none")
                      }
                    >
                      {data.ho_ten || "..."}
                    </a>
                  </div>
                );
              },
            },
            {
              caption: translate("Base.Label.StudentSex"),
              dataField: "gioi_tinh",
              width: "100px",
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <PersonIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.gioi_tinh || "..."}
                    </span>
                  </div>
                );
              },
            },
            {
              caption: "Email",
              dataField: "email_hocsinh",
              width: "100px",
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <MailIcon size={14} />
                    </div>{" "}
                    <TextWithEllipse text={data.email_hocsinh || ""} lineNumber={1} />
                  </div>
                );
              },
            },
            {
              caption: translate("Tên hệ"),
              dataField: "ten_he",
              width: "140px",
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "baseline",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: "3px",
                      }}
                    >
                      <div style={{ color: "green" }}>
                        <LinkIcon size={14} />
                      </div>
                      <Label
                        style={{ marginLeft: "5px" }}
                        variant={
                          data.ten_he === "Bilingual Track"
                            ? "accent"
                            : data.ten_he === "International Track"
                              ? "success"
                              : "default"
                        }
                      >
                        {data.ten_he}
                      </Label>
                    </div>
                  </Box>
                );
              },
            },
            {
              caption: translate("Tên lớp"),
              dataField: "ten_lop",
              width: "100px",
              cellRender: (data: IHocSinhSelectResponeItem) => {
                return <Box sx={{ fontWeight: 600 }}>{data.ten_lop}</Box>;
              },
            },
          ]}
          data={dataSource}
        />
      </Box>

      {isShowModal && canEdit && (
        <HocSinhProfile
          id={hocSinhEditing.id}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleRefresh();
            setIsShowModal(false);
          }}
        />
      )}
      {isShowImageModal && selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(4px)",
          }}
          onClick={() => !isUploading && handleCloseModal()}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "12px",
              maxWidth: "500px",
              width: "90%",
              position: "relative",
              boxShadow:
                "0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)",
              animation: "modalFadeIn 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#24292f",
                }}
              >
                Face ID Image
              </h3>
              {!isUploading && (
                <Button
                  variant="invisible"
                  onClick={handleCloseModal}
                  sx={{
                    padding: "8px",
                    color: "#57606a",
                    borderRadius: "50%",
                    "&:hover": {
                      backgroundColor: "#f6f8fa",
                      color: "#24292f",
                    },
                  }}
                >
                  ✕
                </Button>
              )}
            </div>

            {/* Image Container */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "24px",
                backgroundColor: "#f6f8fa",
                borderRadius: "8px",
                padding: "16px",
              }}
            >
              <img
                src={selectedImage}
                alt="Face ID Large"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "400px",
                  borderRadius: "8px",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Actions */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                borderTop: "1px solid #d0d7de",
                paddingTop: "16px",
              }}
            >
              <Button
                variant="default"
                size="medium"
                onClick={handleCloseModal}
                disabled={isUploading}
                sx={{
                  minWidth: "80px",
                }}
              >
                Đóng
              </Button>
              <Button
                variant="primary"
                size="medium"
                leadingVisual={UploadIcon}
                onClick={(e) =>
                  selectedStudentId && handleUploadFaceId(e, selectedStudentId)
                }
                disabled={isUploading}
                sx={{
                  minWidth: "120px",
                  backgroundColor: "#2da44e",
                  "&:hover": {
                    backgroundColor: "#2c974b",
                  },
                }}
              >
                {isUploading ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span>Đang tải...</span>
                    <div
                      className="spinner"
                      style={{
                        width: "16px",
                        height: "16px",
                        border: "2px solid rgba(255,255,255,0.3)",
                        borderRadius: "50%",
                        borderTopColor: "white",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                  </div>
                ) : (
                  "Thay đổi ảnh"
                )}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HocSinhListContainer;
